import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Cms, TempAny } from '@impact/data';

@Component({
    selector: 'app-checkout-footer-usp',
    template: '<app-usp [items]="items"></app-usp>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutFooterUspComponent {
    @Input() items: Cms.USPItem[] | TempAny[];
}
